<template>
  <el-config-provider :locale="elLocale">
    <ele-config-provider
      :locale="eleLocale"
      :table="tableConfig"
      :map-key="MAP_KEY"
      :license="LICENSE_CODE"
    >
      <ele-app>
        <router-view />
        <UserProfileModal
          v-if="userProfileVisible && userStore.info"
          v-model="userProfileVisible"
        />
      </ele-app>
    </ele-config-provider>
  </el-config-provider>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { MAP_KEY, LICENSE_CODE } from '@/config/setting';
  import { useGlobalConfig } from '@/config/use-global-config';
  import { useUserStore } from '@/store/modules/user';
  import { useThemeStore } from '@/store/modules/theme';
  import { useLocale } from '@/i18n/use-locale';
  import UserProfileModal from '@/layout/components/user-profile-modal.vue';

  const userStore = useUserStore();
  const userProfileVisible = ref(false);
  let checkedUser = '';

  // 用户信息和角色加载完成后检查签名及教师职称；校级管理员无需提醒。
  watch(
    [() => userStore.personalInfo, () => userStore.currRole?.roleCode],
    ([user, roleCode]) => {
      if (!user?.userid) {
        checkedUser = '';
        userProfileVisible.value = false;
        return;
      }
      if (!roleCode || roleCode === 'admin') {
        userProfileVisible.value = false;
        return;
      }
      const userKey = JSON.stringify([user.tenantId, user.userid]);
      if (checkedUser === userKey) return;
      checkedUser = userKey;
      userProfileVisible.value =
        !user.sign?.trim() || (user.category === 1 && !user.job?.trim());
    },
    { immediate: true, flush: 'post' }
  );

  /** 组件全局配置 */
  const { tableConfig } = useGlobalConfig();

  /** 恢复缓存主题 */
  const themeStore = useThemeStore();
  themeStore.recoverTheme();

  /** 国际化配置 */
  const { elLocale, eleLocale } = useLocale();
</script>
